import LoadingButton from '@mui/lab/LoadingButton';
import { Alert, Box } from '@mui/material';
import { useTokenMutation } from 'api/oauth/oauth';
import LoginForm from 'components/forms/login-form/login-form.component';
import { useLoginForm } from 'components/forms/login-form/login-form.hooks';
import LoginLayout from 'components/layouts/login-layout/login-layout.component';
import { useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { selectIsAuthenticated } from 'redux/user/user.selectors';

const Login = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const [token, { isLoading }] = useTokenMutation();
  const formMethods = useLoginForm();
  const { t } = useTranslation();
  const [error, setError] = useState(false);

  const onSubmit = async data => {
    try {
      setError(false);
      await token(data).unwrap();
    } catch (e) {
      if (e?.status === 401) setError(true);
    }
  };

  if (isAuthenticated)
    return (
      <Navigate to={window.history.state?.usr?.from?.pathname ?? '/'} replace />
    );

  return (
    <LoginLayout>
      <FormProvider {...formMethods}>
        <form
          onSubmit={formMethods.handleSubmit(onSubmit)}
          data-testid="LoginPage.Form"
        >
          <LoginForm />

          <Box mt={1}>
            {!!error && (
              <Alert sx={{ mb: '4px' }} severity="error">
                {t('page.login.error')}
              </Alert>
            )}

            <LoadingButton
              type="submit"
              fullWidth
              sx={{ mt: 1 }}
              loading={isLoading}
              variant="contained"
              data-testid="Login.LoadingButton"
            >
              {t('forms.buttons.submit')}
            </LoadingButton>
          </Box>
        </form>
      </FormProvider>
    </LoginLayout>
  );
};

export default Login;
